export const presentConstruction = submissionVM =>
    submissionVM.lobData.homeowners.coverables.dwellings.value.every(
        dwelling => dwelling.construction?.heaters.length > 0
    );
